import React from "react";
import PropTypes from "prop-types";
import { Form, Input } from "semantic-ui-react";
import InputMask from "react-text-mask";
import Erro from "../../layouts/mensagens/Erro";
import InfinitySelect from "../../layouts/InfinitySelect";
import { SecaoForm } from "../../layouts/FormUI";
import { HORA_PATTERN } from "../../../utils/patterns";
import CampoData from "../../layouts/CampoData";

const Data = ({ id, label, valor, onChange, erro, dica }) => (
  <Form.Field error={!!erro} required>
    <label htmlFor={id}>{label}</label>
    <CampoData id={id} name={id} value={valor} onChange={onChange} />
    {!!dica && <small className="va-campo-dica">{dica}</small>}
    <Erro text={erro} />
  </Form.Field>
);

const Hora = ({ id, label, valor, onChange, erro, dica }) => (
  <Form.Field error={!!erro}>
    <label htmlFor={id}>{label}</label>
    <InputMask type="text" id={id} name={id} mask={HORA_PATTERN} guide={true} placeholder="hh:mm" value={valor || ""} onChange={onChange} />
    {!!dica && <small className="va-campo-dica">{dica}</small>}
    <Erro text={erro} />
  </Form.Field>
);

// Campos da reunião compartilhados entre o cadastro e a edição da votação.
const CamposReuniao = ({ valores, errors, onChange, onChangeSelect, getResponsaveis }) => (
  <>
    <SecaoForm icone="calendar check outline" titulo="Reunião" descricao="Quando e onde a reunião acontece.">
      <Form.Group widths={2}>
        <Form.Field error={!!errors.titulo} required>
          <label htmlFor="titulo">Título da votação</label>
          <Input id="titulo" name="titulo" type="text" placeholder="Ex.: Assembleia geral ordinária 2026" onChange={onChange} value={valores.titulo || ""} />
          <Erro text={errors.titulo} />
        </Form.Field>
        <Form.Field error={!!errors.local}>
          <label htmlFor="local">Local da reunião</label>
          <Input id="local" name="local" type="text" placeholder="Ex.: Salão de festas ou online" onChange={onChange} value={valores.local || ""} />
          <Erro text={errors.local} />
        </Form.Field>
      </Form.Group>
      <Form.Group widths={2}>
        <Data id="dataInicioReuniao" label="Data da reunião" valor={valores.dataInicioReuniao} onChange={onChange} erro={errors.dataInicioReuniao} />
        <Hora id="horarioReuniao" label="Horário da reunião" valor={valores.horarioReuniao} onChange={onChange} erro={errors.horarioReuniao} />
      </Form.Group>
      <Form.Field error={!!errors.urlTransmissao}>
        <label htmlFor="urlTransmissao">Link de acesso ou transmissão <small>(opcional)</small></label>
        <Input id="urlTransmissao" name="urlTransmissao" type="text" placeholder="Link do Zoom, YouTube, Meet, Teams, Skype..." onChange={onChange} value={valores.urlTransmissao || ""} />
        <Erro text={errors.urlTransmissao} />
      </Form.Field>
    </SecaoForm>

    <SecaoForm icone="clock outline" titulo="Prazo para votar" descricao="Depois do término, os resultados ficam disponíveis para todos em 5 minutos.">
      <Form.Group widths={2}>
        <Data id="dataFinalReuniao" label="Data limite para votações" valor={valores.dataFinalReuniao} onChange={onChange} erro={errors.dataFinalReuniao} />
        <Hora id="horarioFinalReuniao" label="Horário limite para votações" valor={valores.horarioFinalReuniao} onChange={onChange} erro={errors.horarioFinalReuniao} />
      </Form.Group>
    </SecaoForm>

    <SecaoForm icone="users" titulo="Mesa" descricao="Quem preside e quem secreta a reunião (opcional).">
      <Form.Group widths={2}>
        <Form.Field>
          <InfinitySelect fluid label="Presidente" name="presidente" options={getResponsaveis("presidente")} onChange={onChangeSelect} value={valores.presidente} />
        </Form.Field>
        <Form.Field>
          <InfinitySelect fluid label="Secretário" name="secretario" options={getResponsaveis("secretário")} onChange={onChangeSelect} value={valores.secretario} />
        </Form.Field>
      </Form.Group>
    </SecaoForm>
  </>
);

CamposReuniao.propTypes = {
  valores: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
  getResponsaveis: PropTypes.func.isRequired,
};

export default CamposReuniao;
